// extracted by mini-css-extract-plugin
export default {"wrap":"VJ-z","articleImagesWrap":"WJ-z","articleImage":"XJ-z","singleImage":"YJ-z"};